<template lang="pug">
    el-dialog(:title="!ruleForm.id ? '新增会员': '修改会员信息'",:fullscreen="false",:visible.sync='visible' :modal-append-to-body='false'  :close-on-click-modal='false')
      el-form(:model="ruleForm",:inline="false" :rules="rules", ref="ruleForm", label-width="100px",  label-suffix=":", @keyup.enter.native="ruleFormSubmit()")
          el-form-item(label="姓名" prop="name")
              el-input(v-model="ruleForm.name" placeholder="请填写姓名" )
          el-form-item(label="账户属性" prop="accountType")
            el-radio-group(v-model="ruleForm.accountType" @change="accountTypeChange")
              el-radio(:label="0") 一般账户
              el-radio(:label="1") 青少年账户           
          el-form-item(label="会员账号" prop="mobile" v-if="ruleForm.accountType==0")
              el-input(v-model="ruleForm.mobile"  placeholder="请填写手机号" @blur="phoneCheck")
          //- el-form-item(label="会员账号"  v-if="ruleForm.accountType==1")
          //-     el-input(v-model="ruleForm.mobile"  disabled placeholder="请填写手机号" @blur="phoneCheck")
          el-form-item(label="证件号" prop="idCard")
            //- el-form-item(label="身份证号" prop="idCard")
            div(style="display:flex")
              add
              el-select.selectWidth(v-model="ruleForm.certificateType" placeholder="请选择证件类型" @change='CertificateVerification' clearable style="margin-right:10px")
                    el-option(v-for="(item,index) in certificateTypeData" :key="index" :label="item.name" :value="item.code")
              el-input(v-model="ruleForm.idCard" :disabled="!ruleForm.certificateType"  placeholder="请填写证件号码")
              //- el-input(v-model="ruleForm.idCard"  placeholder="请填写证件号码" @blur="birtCheck" )
          el-form-item(label="出生日期" prop="birthday")
              el-tooltip(class="item" effect="dark" content="输入身份证号将自动带入出生日期" placement="right")
                el-date-picker.selectWidth(v-model="ruleForm.birthday" type="date" placeholder="请先选择出生日期" :picker-options="pickerOptions" format="yyyy-MM-dd" value-format="yyyy-MM-dd" clearable)
          el-form-item(label="性别" prop="gender")
              el-radio(v-model="ruleForm.gender" :label="0") 男
              el-radio(v-model="ruleForm.gender" :label="1") 女
          el-form-item(label="我是" prop="professional")
               el-select.selectWidth(v-model="ruleForm.professional" placeholder="请选择" clearable)
                    el-option(v-for="(item,index) in professionalData",:key="index",:label="item.name",:value="item.code")
          el-form-item(label="常驻地" prop="locationAddress")
              el-cascader(v-model="ruleForm.locationAddress" :options="options" :props="props" @change="cityChange")
          el-form-item(label="个人级别" prop="level")
              el-select.selectWidth(:disabled="ruleForm.id ? true : false" v-model="ruleForm.level" placeholder="请选择个人级别" clearable)
                el-option(label="0.0" value="0.0")
                el-option(label="1.0" value="1.0")
                el-option(label="1.5" value="1.5")
                el-option(label="2.0" value="2.0")
                el-option(label="2.5" value="2.5")
                el-option(label="3.0" value="3.0")
                el-option(label="3.5" value="3.5")
                el-option(label="4.0" value="4.0")
                el-option(label="4.5" value="4.5")
                el-option(label="5.0" value="5.0")
          //- el-form-item(label=`专业运动员` prop="professional")
          //-     el-radio(v-model="ruleForm.professional" label="0") 是
          //-     el-radio(v-model="ruleForm.professional" label="1") 否
          el-form-item(label="会员类别" prop="type")
              el-select.selectWidth(v-model="ruleForm.type" placeholder="请选择会员类别" clearable)
                  el-option(label="注册会员" :value="1")
                  el-option(label="初始会员" :value="2")
                  el-option(label="荣誉会员" :value="3")
          //- el-form-item(label="主办方" prop="orgId")
          //-     el-select.selectWidth(v-model="ruleForm.orgId" placeholder="请选择主办方" clearable)
          //-       el-option(v-for="(item,index) in sysOrgList",:key="index",:label="item.name",:value="item.orgId")
          el-form-item(label="身份属性" prop="identity")
              el-select.selectWidth(v-model="ruleForm.identity" placeholder="请选择身份属性" clearable)
                  el-option(label="在职人员" :value="1")
                  el-option(label="在校人员" :value="2")
                  el-option(label="退休人员" :value="3")
                  el-option(label="志愿者" :value="4")
                  el-option(label="家长" :value="5")
                  el-option(label="其他" :value="6")
          el-form-item(label="头像" prop="headImg")
              el-input(v-model="ruleForm.headImg" v-show="false")
              el-upload(:http-request="uploadSectionFile",action="useless" :headers="headers", :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
                  img(v-if="imageUrl" :src="imageUrl" class="avatar" )
                  i(v-else class="el-icon-plus avatar-uploader-icon")
          el-form-item(label="昵称" prop="nickname")
              el-input(v-model="ruleForm.nickname" placeholder="请填写昵称" )
          el-form-item(label="俱乐部" prop="clubName" v-if='ruleForm.id')
              font {{ruleForm.clubName||'未加入俱乐部'}}
      span.dialog-footer(slot="footer")
          el-button(type="primary" @click="ruleFormSubmit()" :disabled="clickFlag") 保 存
          el-button(@click="visible=false") 返 回
</template>
<script>
let id = 0;
import util from '@/libs/util.js'
import { commomDictData } from '@/util/dictionary' // 字典项
export default {
  data () {
    let _self = this;
    return {
       props: {
          multiple: true,
          // checkStrictly:true,
          // leaf:'cityName'
        },
      uploadUrl: this.$http.adornUrl(`/upload/uploadFile`),
      uploadData: null,
      sysOrgList: [],
      //文件上传时授权
      headers: {
        token: util.cookies.get('token'),
        authorization: 'Bearer ' + util.cookies.get('authorization'),
        'Content-Type': 'application/json; charset=utf-8'
      },
      clickFlag: false,
      certificateTypeData: [], // 身份类型
      professionalData: [], // 我是
      proviceList: [], // 省份信息
      allCityList:[],
      cityList: [], // 市信息
      ruleForm: {
        id: null,
        name: '',
        mobile: '',
        idCard: '',
        birthday: null,
        gender: null,
        accountType:0,
        level: '',
        type: 1,
        orgId: '',
        identity: 6,
        headImg: '',
        nickname: '',
        certificateType: '', // 证件类型
        professional: '', // 我是
        provinceId: '', // 市
        cityId: '' ,// 省
        locationAddress:[],
        
      },
      options:[],
      // locationAddress:[],
      rules: {
        name: [
          { required: true, message: '姓名不能为空!', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '会员账号不能为空!', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码' }
        ],
        idCard: [
          { required: true, message: '证件号不能为空!', trigger: 'blur' },
          {
            pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
            message: '请输入正确的身份证号'
          }
        ],
        locationAddress:[
          { required: true, message: '请选择常住地!', trigger: 'change' }
        ],
        birthday: [
          { required: true, message: '出生日期不能为空!', trigger: 'change' }
        ],
        gender: [
          { required: true, message: '必须选择性别!', trigger: 'change' }
        ],
        level: [
          { required: true, message: '个人级别不能为空!', trigger: 'change' }
        ],

        identity: [
          { required: true, message: '身份属性不能为空!', trigger: 'change' }
        ],
        professional: [
          {
            required: true,
            message: '必须选择是否为专业运动员!',
            trigger: 'change'
          }
        ],
        nickname: [
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ]
      },
      visible: false,
      pickerOptions: {
        disabledDate: time => {
          return time > new Date()
        }
      },
      imageUrl: ''
    }
  },
  mounted () {
    commomDictData('certificate_type', this).then(res => { // 身份类型
      this.certificateTypeData = res.list
    })
    commomDictData('capability_type', this).then(res => { // 我是
      this.professionalData = res.list
    })
    this.initProvice()
    this.initallCity()
    this.initProviceCity()
  },
  methods: {
    cityChange(value){
       console.log('selectes',value)
    },
    
    //证件验证切换
    CertificateVerification () {
      console.log(this.ruleForm.certificateType)
      if (this.ruleForm.certificateType == 1) {
        this.rules.idCard[1] = {
          // pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
          pattern:/^\d{6}((((((19|20)\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(((19|20)\d{2})(0[13578]|1[02])31)|((19|20)\d{2})02(0[1-9]|1\d|2[0-8])|((((19|20)([13579][26]|[2468][048]|0[48]))|(2000))0229))\d{3})|((((\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|((\d{2})(0[13578]|1[02])31)|((\d{2})02(0[1-9]|1\d|2[0-8]))|(([13579][26]|[2468][048]|0[048])0229))\d{2}))(\d|X|x)$/,
          message: '请输入正确的身份证号'
        }
        this.$refs.ruleForm.validateField('idCard')
      } else if (this.ruleForm.certificateType == 2) {
        this.rules.idCard[1] = {
          pattern: /^[a-zA-Z0-9]{11}$/,
          message: '请输入正确的港澳台通行证'
        }
        this.$refs.ruleForm.validateField('idCard')
      } else if (this.ruleForm.certificateType == 3) {
        this.rules.idCard[1] = {
          // pattern: /(^[AaBbCcDdEeFfIiJjLlMmNnKkGgDdSsPpHh]\d{8}$)|(^(([Ee][a-fA-F])|([DdSsPp][Ee])|([Kk][Jj])|([Mm][Aa])|(1[45]))\d{7}$)/,
          // pattern: /(^[A-Za-z]\d{8}$)|(^(([Ee][a-fA-F])|([DdSsPp][Ee])|([Kk][Jj])|([Mm][Aa])|(1[45]))\d{7}$)/,
          // message: '请输入正确的护照'
        }
        this.$refs.ruleForm.validateField('idCard')
      }
    },
    // 获取省市
    initProviceCity(){
      this.$http({
        url: this.$http.adornUrl('/dicProvince/getProvinceCity'),
        method: 'get',
        params:{}
      }).then((data) => {
        this.options = data && data.code === 0 ? data.data : []

      })
    },
    // 获取省下拉数据
    initProvice () {
      this.$http({
        url: this.$http.adornUrl('/dicProvince/list'),
        method: 'get',
        params: this.$http.adornParams()
      }).then((data) => {
        this.proviceList = data && data.code === 0 ? data.list : []
      })
    },

    // 获取所有市
    initallCity () {
      this.$http({
        url: this.$http.adornUrl('/dicProvinceCity/list'),
        method: 'get',
        params: ""
      }).then((data) => {
        this.allCityList = data && data.code === 0 ? data.list : []

      })
    },
    // 获取市下拉数据
    changeProvice () {
      console.log(this.ruleForm.provinceId)
      console.log(this.proviceList)
      this.proviceList.forEach((item) => {
        if (item.proviceId == this.ruleForm.provinceId) {
          this.ruleForm.provinceName = item.name
        }
      })
      console.log(this.ruleForm.provinceName)
      this.cityList = []
      this.ruleForm.cityId = '' // 置空操作
      this.$http({
        url: this.$http.adornUrl('/dicProvinceCity/list'),
        method: 'get',
        params: this.$http.adornParams({
          'proviceId': this.ruleForm.provinceId
        })
      }).then((data) => {
        this.cityList = data && data.code === 0 ? data.list : []
      })
    },
    // 
    changeCityId () {
      this.cityList.forEach((item) => {
        if (item.cityId == this.ruleForm.cityId) {
          this.ruleForm.cityName = item.cityname
        }
      })
    },
    init (id) {
      this.$forceUpdate()
      console.log("this.$refs['ruleForm']:", this.$refs['ruleForm'])
      this.clickFlag = false
      this.ruleForm.id = id || null
      this.imageUrl = ''
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get',
        params: this.$http.adornParams({
          cityId: '',
          proviceId: ''
        })
      })
        .then(data => {
          this.sysOrgList = data && data.code === 0 ? data.list : []
          // console.log('主办方', this.sysOrgList)
          // if (data.list && data.list.length > 0) {
          //   this.ruleForm.orgId = data.list[0].orgId
          // }
          this.ruleForm.orgId = ''
        })
        .then(() => {
          this.$nextTick(() => {
            this.visible = true
            // console.log("this.$refs['ruleForm']:",this.$refs['ruleForm'])
            if (this.$refs['ruleForm']) {
              this.$refs['ruleForm'].resetFields()
            }
          })
        })
        // 
        .then(() => {
          if (this.ruleForm.id) {
            this.$http({
              url: this.$http.adornUrl(`/mbMember/getId/${this.ruleForm.id}`),
              method: 'get',
              params: this.$http.adornParams()
            }).then(data => {
              console.log('初始化信息', data)
              if (data && data.code === 0) {
                this.ruleForm.name = data.bean.name
                this.ruleForm.mobile = data.bean.mobile
                this.ruleForm.idCard = data.bean.idCard
                this.ruleForm.birthday = data.bean.birthday
                this.ruleForm.gender = data.bean.gender
                this.ruleForm.level = data.bean.level
                // this.ruleForm.type = data.bean.type || 1
                this.ruleForm.type = data.bean.type || null
                this.ruleForm.orgId = data.bean.orgId
                this.ruleForm.identity = data.bean.identity || 6
                this.ruleForm.headImg = data.bean.headImg
                this.ruleForm.nickname = data.bean.nickname
                this.ruleForm.clubName = data.bean.clubName
                this.ruleForm.certificateType = data.bean.certificateType // 证件类型
                this.ruleForm.professional = data.bean.professional // 我是
                this.ruleForm.accountType=data.bean.accountType
                let res=[]
                JSON.parse(data.bean.locationAddress).map(item=>{
                  let arrObj=[
                   item.provinceId,item.cityId
                   ]
                   res.push(arrObj)
                })
                this.ruleForm.locationAddress=res
                this.$nextTick(() => { this.ruleForm.cityId = data.bean.cityId }) // 市
                if (data.bean.imgUrl !== '' && data.bean.imgUrl != null) {
                  this.imageUrl = data.bean.imgUrl
                  // this.imageUrl = "data:image/png;base64,"+data.bean.imgUrl
                } else {
                  this.imageUrl = require('../img/img.jpg')
                }
                if (this.ruleForm.certificateType == 1) {
                  this.rules.idCard[1] = {
                    pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
                    message: '请输入正确的身份证号'
                  }
                  this.$refs.ruleForm.validateField('idCard')
                } else if (this.ruleForm.certificateType == 2) {
                  this.rules.idCard[1] = {
                    pattern: /^[a-zA-Z0-9]{11}$/,
                    message: '请输入正确的港澳台通行证'
                  }
                  this.$refs.ruleForm.validateField('idCard')
                } else if (this.ruleForm.certificateType == 3) {
                  this.rules.idCard[1] = {
                    // pattern: /^[a-zA-Z0-9]{9}$/,
                    // message: '请输入正确的护照'
                  }
                  this.$refs.ruleForm.validateField('idCard')
                }
              }
            })
          }
        })
    },
    phoneCheck () {
      let phoneNum = this.ruleForm.mobile
      if (phoneNum != null && phoneNum !== '') {
        this.$http({
          url: this.$http.adornUrl('/mbMember/phoneCheck'),
          method: 'post',
          params: this.$http.adornParams({
            mobile: phoneNum,
            id: this.ruleForm.id
          })
        }).then(data => {
          if (data.num !== 0) {
            this.$message.error('手机号已存在!')
            this.ruleForm.mobile = ''
          }
        })
      }
    },

    accountTypeChange(e){
        // e==1?this.ruleForm.mobile=null:"0"
        // this.$forceUpdate()
    },
    // birtCheck () {
    //   let card_no = this.ruleForm.idCard
    //   let birthday = ''

    //   if (card_no != null && card_no !== '') {
    //     if (card_no.length === 15) {
    //       birthday = '19' + card_no.substr(6, 6)
    //     } else if (card_no.length === 18) {
    //       birthday = card_no.substr(6, 8)
    //     }
    //   }
    //   birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-')
    //   this.ruleForm.birthday = birthday
    // },
    //新增方法
    ruleFormSubmit () {
      console.log(this.ruleForm)
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {

        // this.clickFlag = true
        // if(this.locationAddress.length==0){
        //   this.$message.error("常住地不能为空")
        //   return
        // }
        let locationAddress = []
        this.ruleForm.locationAddress.forEach(item => {
            let obj = {
                provinceId: "",
                provinceName: "",
                cityId: "",
                cityName: ""
            } 
            this.proviceList.forEach(proItem => {
                if (proItem.proviceId == item[0]) {
                    obj.provinceName = proItem.name
                    obj.provinceId = proItem.proviceId
                }
            })
            this.allCityList.forEach(cityItem => {
                if (cityItem.cityId == item[1]) {
                    obj.cityName = cityItem.cityname
                    obj.cityId = cityItem.cityId
                }
            })

            locationAddress.push(obj)
        })
          console.log('locationAddress',locationAddress)
          this.$http({
            url: this.$http.adornUrl(
              `/mbMember/${!this.ruleForm.id ? 'save' : 'update'}`
            ),
            method: 'post',
            data: {
              id: this.ruleForm.id || undefined,
              name: this.ruleForm.name,
              mobile: this.ruleForm.mobile,
              idCard: this.ruleForm.idCard,
              birthday: this.ruleForm.birthday,
              gender: this.ruleForm.gender,
              level: this.ruleForm.level,
              type: this.ruleForm.type || 0,
              orgId: this.ruleForm.orgId,
              identity: this.ruleForm.identity,
              headImg: this.ruleForm.headImg,
              nickname: this.ruleForm.nickname,
              deleted: 0,
              status: 1,
              byx1: this.ruleForm.byx1,
              byx2: this.ruleForm.byx2,
              byx3: this.ruleForm.byx3,
              certificateType: this.ruleForm.certificateType, // 证件类型
              professional: this.ruleForm.professional, // 我是
              locationAddress:JSON.stringify(locationAddress), 
              accountType:this.ruleForm.accountType
            }
          }).then(data => {
            console.log(data)
            if (data && data.code === 0) {
              this.clickFlag = true
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshDataList')
                }
              })
            }
            //  else {
            //   this.$message.error(data.error)
            // }
          })
        }
      })
    },
    //文件上传前的验证
    beforeAvatarUpload (file) {
      const isJPG =
        file.type === 'image/jpg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片只能是 jpg,jpeg,png 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    //自定义上传方法
    //没有用el-upload的action方法，如果使用要传递headers属性参数授权
    uploadSectionFile (param) {
      let fd = new FormData()
      fd.append('type', 'mbMember')
      fd.append('file', param.file)

      this.$http({
        url: this.$http.adornUrl(`/upload/uploadFile`),
        method: 'post',
        data: fd
      }).then(data => {
        if (data && data.code === 0) {
          this.ruleForm.headImg = data.bean.id
          this.imageUrl = URL.createObjectURL(param.file)
          this.ruleForm.byx3 = '0'
          this.$message.success('上传成功!')
        } else {
          this.$message.error('上传失败!')
        }
      })
    }
  },
  // watch: {
  //   'ruleForm.idCard': {
  //     handler (newVal, oldVal) {
  //       let birthday = ''
  //       if (newVal.length === 15 || newVal.length === 18) {
  //         if (newVal.length == 15) {
  //         birthday = '19' + newVal.slice(6, 12)
  //         } else if (newVal.length == 18) {
  //         birthday = newVal.slice(6, 14)
  //         }
  //         this.ruleForm.birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-');
  //       } else {
  //         this.ruleForm.birthday = null
  //       }
  //     },
  //     deep: true
  //   }
  // }
}
</script>
<style>
.selectWidth {
  width: 220px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/* 弹出遮罩层 兼容ie*/
.el-dialog__wrapper {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
}
</style>
